import React from 'react';
import Modal from '~/components/ModalNewVehicle';
import { ContainerModal, TitleModal, Divider } from '../../../MapOpportunities/styles';
import InfoPanel from '../../../MapOpportunities/components/MapModalSections/InfoPanel';
import NameValueItem from '../../../MapOpportunities/components/MapModalSections/NameValueItem';
import { HinovaAssociado, HinovaHistorico } from '~/types';
import { Table } from '~/components/Table';

interface AssociadoDetailsProps {
  associado: HinovaAssociado;
  historico: HinovaHistorico[];
  open: boolean;
  onClose: () => void;
}

const AssociadoDetails: React.FC<AssociadoDetailsProps> = ({ associado, historico, open, onClose }) => {
  return (
    <Modal onConfirm={onClose} onCancel={onClose} open={open} question={false} buttonPositive='Fechar'>
      <ContainerModal>
        <TitleModal>Detalhes do Associado</TitleModal>
        <Divider height={15} />

        <InfoPanel title='Informações Pessoais'>
          <NameValueItem title='CPF'>{associado.cpf || 'N/A'}</NameValueItem>
          <NameValueItem title='Nome'>{associado.nome || 'N/A'}</NameValueItem>
          <NameValueItem title='Email'>{associado.email || 'N/A'}</NameValueItem>
          <NameValueItem title='Telefone'>{associado.telefone || 'N/A'}</NameValueItem>
          <NameValueItem title='Endereço'>{associado.endereco || 'N/A'}</NameValueItem>
        </InfoPanel>

        <InfoPanel title='Informações da Cooperativa'>
          <NameValueItem title='Cooperativa'>{associado.cooperativa || 'N/A'}</NameValueItem>
          <NameValueItem title='Situação'>{associado.situacao || 'N/A'}</NameValueItem>
        </InfoPanel>

        {historico && historico.length > 0 && (
          <>
            <Divider height={20} />
            <InfoPanel title='Histórico'>
              <Table
                data={historico}
                columns={{
                  data: { title: 'Data', render: rowData => rowData.data || '-' },
                  tipo: { title: 'Tipo', render: rowData => rowData.tipo || '-' },
                  descricao: { title: 'Descrição', render: rowData => rowData.descricao || '-' },
                }}
                localization={{
                  body: { emptyDataSourceMessage: 'Nenhum histórico encontrado.' },
                }}
                options={{
                  showTitle: false,
                  pageSize: 5,
                  paging: true,
                  filtering: false,
                  search: false,
                }}
              />
            </InfoPanel>
          </>
        )}
      </ContainerModal>
    </Modal>
  );
};

export default AssociadoDetails;
